import { lazy } from "react";

export const UploadConfig = lazy(() => import("./UploadConfig"));
